import React from 'react';
import { t } from '../../../../shared/components/l10n/l10n';
import { Modal } from '@economic/gaudi';
import ModalFooter from './ModalFooter';

export default function StepOnboard() {
    return (
        <>
            <Modal.Content>
                <div className="moneyflow__onboarding moneyflow__onboarding__error">
                    <h1>{t`MONEYFLOW_ONBOARDING_ERROR_UNKNOWN_HEADER`}</h1>
                    <p>{t`MONEYFLOW_ONBOARDING_ERROR_UNKNOWN_DESCRIPTION`}</p>
                </div>
            </Modal.Content>
            <ModalFooter />
        </>
    );
}
